module.exports = __webpack_public_path__ + "static/fonts/Fact-Bold.0a41a0d.eot";